export const VALID_WORDS = [
  "BULLS",
  "BEARS",
  "TRADE",
  "STOCK",
  "PRICE",
  "TREND",
  "CHART",
  "BREAK",
  "PIVOT",
  "ORDER",
  "CLOSE",
  "LONGS",
  "SHORT",
  "GAINS",
  "GREEN",
  "PEAKS",
  "RALLY",
  "CARRY",
  "YIELD",
  "FUNDS",
  "SPLIT",
  "LIMIT",
  "FLOAT",
  "HEDGE",
  "DEBIT",
  "BONDS",
  "COVER",
  "DRAWUP",
  "SALES",
  "SHARE",
];

export const getRandomWord = () => {
  return VALID_WORDS[Math.floor(Math.random() * VALID_WORDS.length)];
};

export const isValidGuess = (word) => {
  return VALID_WORDS.includes(word.toUpperCase());
};
